import React from "react";
import {Link, useLocation} from "react-router-dom";
import {RouteDefine} from "../../routes/RouteDefine";
import {
    getSettingsBusinessPath,
    getSettingsEconomicPath,
    getSettingsStripePath,
} from "../../routes/settingsPaths";
import {getSyncEngineVersion} from "../../common/helpers/syncEngine";
import {useTranslation} from "react-i18next";

/** Product group mapping — hidden until feature is ready */
const SHOW_PRODUCT_GROUP = false;

const LeftSideBar01: React.FC = () => {
    const location = useLocation();
    const {t} = useTranslation();
    const isV2 = getSyncEngineVersion() === "v2";

    const isActive = (canonical: string, legacy?: string) =>
        location.pathname === canonical
        || (legacy != null && location.pathname === legacy);

    const itemClass = (canonical: string, legacy?: string) =>
        (isActive(canonical, legacy) ? "active" : "");

    return (
        <div className="col-md-auto">
            <div className="siderbar-nav-left mt-3 w-195">
                <h3 className="fs-16 cl-ams fw-bold mb-4">{t("common.leftSidebarO1.settings")}</h3>
                <ul className="pl-0">
                    {isV2 ? (
                        <>
                            <li className={itemClass(RouteDefine.settings, undefined)}>
                                <Link to={RouteDefine.settings}>{t("common.settingsOverview.overview")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.settingsEconomic, RouteDefine.economic)}>
                                <Link to={getSettingsEconomicPath()}>{t("common.leftSidebarO1.eConomic")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.settingsStripe, RouteDefine.stripe)}>
                                <Link to={getSettingsStripePath()}>{t("common.leftSidebarO1.stripe")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.settingsBusiness, RouteDefine.business)}>
                                <Link to={getSettingsBusinessPath()}>{t("common.leftSidebarO1.businessInfo")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.settingsSchedule)}>
                                <Link to={RouteDefine.settingsSchedule}>{t("common.leftSidebarO1.schedule")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.help)}>
                                <Link to={RouteDefine.help}>{t("common.leftSidebarO1.help")}</Link>
                            </li>
                        </>
                    ) : (
                        <>
                            <li className={itemClass(RouteDefine.settingsBusiness, RouteDefine.business)}>
                                <Link to={getSettingsBusinessPath()}>{t("common.leftSidebarO1.businessInfo")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.settingsEconomic, RouteDefine.economic)}>
                                <Link to={getSettingsEconomicPath()}>{t("common.leftSidebarO1.eConomic")}</Link>
                            </li>
                            <li className={itemClass(RouteDefine.settingsStripe, RouteDefine.stripe)}>
                                <Link to={getSettingsStripePath()}>{t("common.leftSidebarO1.stripe")}</Link>
                            </li>
                            {SHOW_PRODUCT_GROUP ? (
                                <li className={itemClass(RouteDefine.settingsProductGroup)}>
                                    <Link to={RouteDefine.settingsProductGroup}>{t("common.leftSidebarO1.product")}</Link>
                                </li>
                            ) : null}
                            <li className={itemClass(RouteDefine.settingsSchedule)}>
                                <Link to={RouteDefine.settingsSchedule}>{t("common.leftSidebarO1.schedule")}</Link>
                            </li>
                        </>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default React.memo(LeftSideBar01);
